import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// The build is prerendered to static HTML per route (see scripts/prerender.js)
// so crawlers and link-preview bots get full, visible content. On a real visit
// React mounts fresh into #root, replacing that prerendered markup. We render
// (rather than hydrate) on purpose: scroll-reveal toggles classes at runtime,
// which would otherwise cause hydration mismatches.
const container = document.getElementById('root');
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
